import React from 'react';
import ClientPage from '../../@common/hoc/ClientPage/index';
import asyncComponent from '../../@common/utility/asyncComponent';

const DetailActivity = asyncComponent(
  () => import('../../modules/clients/DetailActivity'),
  true,
);
export default ClientPage(() => <DetailActivity />);
